import React, { useEffect, useState } from "react";
import Header from "../../components/header/header";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import {
  approveCompanyAction,
  enableDisableAdvisorAction,
  getBusinessAction,
  makeKimbocorpAdvisorAction,
} from "../../actions/businessInfo";
import { backendUrl, I_POP_OVER } from "../../constants";
import { getSubscriptionPlanList } from "../../actions/subscription";
import { getNotificationAction } from "../../actions/notificationBanner";
import InfoModalStatic from "../../components/infoModal/infoModalStatic";
import { clearAdminAsUserAction } from "../../actions/user";
import TimeFormat from "../../components/timeFormat/timeFormat";
import { getBusinessGroupAction } from "../../actions/bookOfBusiness";
import ConfirmModal from "./ConfirmModal";
import UserMakeAdvisor from "../user/UserMakeAdvisor";
import CompanyDetail from "./CompanyDetail";

export default function AdvisorBusinessDetail() {
  const { businessInfo, count } = useSelector((state) => state.businessInfo);
  const { adminAsuser } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [activePage, setActivePage] = useState(0);
  const [search, setSearch] = useState("");
  const [company, setCompany] = useState(null);
  const [infoModalStaticShow, setInfoModalStaticShow] = useState(false);
  const [confirmAcceptRejectModal, setConfirmAcceptRejectModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [type, setType] = useState(false);
  const limit = 20;
  const [companyDetailModal, setCompanyDetailModal] = useState(false);
  const [companyDetailItem, setCompanyDetailItem] = useState(null);

  /* ------------------ FETCH BUSINESS LIST ------------------ */
  useEffect(() => {
    let timeoutId;

    const fetchData = () => {
      dispatch(getBusinessAction(page, limit, search, "", "", "", "", "", "", "", "", true));
    };

    if (search) {
      timeoutId = setTimeout(fetchData, 500);
    } else {
      fetchData();
    }

    return () => clearTimeout(timeoutId);
  }, [page, search, dispatch,]);

  const handlePageClick = (e) => {
    setActivePage(e.selected);
    setPage(e.selected + 1);
  };

  const handleClickInfo = () => {
    setInfoModalStaticShow(true);
  };

  const filterBodyListAgain = () => ({ page, limit, search, isDefault: true });

  const onSubmitApproval = (item, flag) => {
    dispatch(approveCompanyAction(item?._id, flag, filterBodyListAgain()));
    setActivePage(0);
    setPage(1);
  };

  const openConfirmPopup = (item, type) => {
    setUserId(item)
    setType(type)
    setOpenModal(true)
  }


  const makeAdvisor = async () => {
    if (userId?._id) {
      await dispatch(makeKimbocorpAdvisorAction(userId?._id, filterBodyListAgain()));
      setActivePage(0);
      setPage(1);
      setOpenModal(false)
      setUserId(null)
      setType(false)
    }
  }

  const getUserTemporaryLink = (item) => {
    setCompanyDetailModal(true)
    setCompanyDetailItem(item)
  };
  return (
    <>
      <Header title="Subscription Plans" />
      <UserMakeAdvisor addModalShow={openModal}
        addModalClose={() => setOpenModal(false)} makeadvisor={makeAdvisor}
        message={
          type
            ? "Are you sure you want to assign the selected users as kimbocorp advisors?"
            : "Are you sure you want to remove the selected users from kimbocorp advisors?"
        } />
      <div className="container-fluid py-4">
        <div className="card planList">
          <div className="card-headings">
            <h6 className="font-weight-bolder payment-text mb-0">
              Business verification details
            </h6>
            <img
              src="assets/img/info-icon.svg"
              alt=""
              onClick={handleClickInfo}
            />
          </div>

          <div className="card-header">
            <div className="searchbar">
              <input
                type="search"
                placeholder="Search business name"
                value={search}
                onChange={(e) => setSearch(e.target.value.trimLeft())}
              />
              <img src="assets/img/searchIcon.svg" alt="" />
            </div>
          </div>

          <div className="card-body detail">
            <table className="businessTable">
              <thead>
                <tr>
                  <td>kimbocorp advisor</td>
                  <td>Logo</td>
                  <td>Holding company name</td>
                  <td>Date added</td>
                  <td>Updated at</td>
                  <td>Created by</td>
                  <td>Action</td>
                </tr>
              </thead>

              <tbody>
                {businessInfo.length > 0 ? (
                  businessInfo.map((ele, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          maxLength={50}
                          autoComplete="off"
                          onChange={(e) =>
                            openConfirmPopup(ele, e.target.checked)
                          }
                          type="checkbox"
                          checked={ele.isKimbocorpAdvisor}
                        />
                      </td>
                      <td>
                        <div
                          className={`business-image ${ele.logo ? "hasLogo" : "hasText"
                            }`}
                          style={{
                            backgroundImage:
                              ele.logo && `url(${backendUrl + ele.logo})`,
                          }}
                        >
                          {!ele.logo && ele.companyName?.[0]}
                        </div>
                      </td>

                      <td onClick={() => getUserTemporaryLink(ele)} className="cursor-pointer">
                        <h5>{ele.companyName || "-"}</h5>
                      </td>

                      <td>
                        <TimeFormat time={ele.createdAt} />
                      </td>

                      <td>
                        <TimeFormat time={ele.updatedAt} />
                      </td>

                      <td>
                        {ele?.user?.[0]?.first_name
                          ? `${ele.user[0].first_name} ${ele.user[0].last_name}`
                          : "-"}
                      </td>

                      <td>
                        {!ele?.isAdminApproved && ele?.isActive ? (
                          <button
                            className="btn save-btn editButton"
                            onClick={() => {
                              setCompany(ele);
                              setConfirmAcceptRejectModal(true);
                            }}
                          >
                            View details
                          </button>
                        ) :
                          ele?.isAdminApproved && ele?.isActive ?
                            "Approved"
                            :
                            'Setup pending'
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center pt-3">
                      No Business Details Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {count > 1 && (
          <div className="pagination-section">
            <ReactPaginate
              previousLabel="Prev"
              nextLabel="Next"
              pageCount={count}
              onPageChange={handlePageClick}
              containerClassName="pagination"
              activeClassName="active"
              forcePage={activePage}
            />
          </div>
        )}
      </div>

      <InfoModalStatic
        infoModalStaticShow={infoModalStaticShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={I_POP_OVER.BUSINESS_DETAIL}
      />

      <ConfirmModal
        show={confirmAcceptRejectModal}
        onClose={() => setConfirmAcceptRejectModal(false)}
        company={company}
        onSubmitApproval={onSubmitApproval}
        isDefault={true}
      />

      <CompanyDetail
        addModalShow={companyDetailModal}
        addModalClose={() => setCompanyDetailModal(false)}
        item={companyDetailItem} />
    </>
  );
}
